import type { ImpactType } from './units';
import type { Tree, TreeType } from '../tree';
import type { CarbonOffset, CarbonOffsetType } from '../carbon-offsets';
import type { CarbonRemoval, CarbonRemovalType } from '../carbon-removal';
import type { HabitatRestoration, HabitatRestorationType } from '../habitat-restoration';

export type ImpactFromImpactType<T extends ImpactType> = {
  [ImpactType.TREES]: Tree | TreeType;
  [ImpactType.CARBON_OFFSETS]: CarbonOffset | CarbonOffsetType;
  [ImpactType.CARBON_REMOVAL]: CarbonRemoval | CarbonRemovalType;
  [ImpactType.HABITAT_RESTORATION]: HabitatRestoration | HabitatRestorationType;
}[T];
